export default {"src":"/_next/static/media/imageIcon.1e388649.svg","height":16,"width":16};